var render = function render(){var _vm=this,_c=_vm._self._c;return _c('thead',_vm._l((_vm.mappedComponents),function(item,index){return _c(item.component,{key:`${item.type}-${index}`,tag:"component",attrs:{"contents":item.contents}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }